// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"934ac3af","249":"549884ec","584":"e0910883","666":"b13f718e"}[chunkId] + ".chunk.js";
};